// Mock data para Disneylândia Cosméticos e Presentes

export const brands = [
  { 
    id: 1, 
    name: 'Natura', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=NATURA',
    featured: true,
    description: 'Cosméticos naturais e sustentáveis'
  },
  { 
    id: 2, 
    name: 'O Boticário', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=O+BOTICARIO',
    featured: true,
    description: 'Perfumaria e cosméticos de alta qualidade'
  },
  { 
    id: 3, 
    name: 'Eudora', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=EUDORA',
    featured: false
  },
  { 
    id: 4, 
    name: 'Avon', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=AVON',
    featured: false
  },
  { 
    id: 5, 
    name: 'MAC', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=MAC',
    featured: false
  },
  { 
    id: 6, 
    name: 'Vult', 
    logo: 'https://placehold.co/200x80/FFFFFF/0A0A0A?text=VULT',
    featured: false
  }
];

export const categories = [
  { id: 'perfumaria', name: 'Perfumaria', icon: 'Sparkles' },
  { id: 'maquiagem', name: 'Maquiagem', icon: 'Palette' },
  { id: 'skincare', name: 'Skincare', icon: 'Droplets' },
  { id: 'cabelos', name: 'Cabelos', icon: 'Scissors' },
  { id: 'presentes', name: 'Presentes', icon: 'Gift' },
  { id: 'acessorios', name: 'Acessórios', icon: 'Heart' }
];

export const products = [];

export const testimonials = [
  {
    id: 1,
    name: 'Ana Clara',
    role: 'Cliente',
    content: 'Adoro a Disneylândia! Sempre encontro os melhores presentes e cosméticos. Atendimento maravilhoso!',
    rating: 5
  },
  {
    id: 2,
    name: 'Fernanda Souza',
    role: 'Cliente',
    content: 'Os perfumes são incríveis e os preços são justos. Super recomendo para quem busca qualidade.',
    rating: 5
  },
  {
    id: 3,
    name: 'Juliana Lima',
    role: 'Cliente',
    content: 'Melhor loja de cosméticos de Canaã! Variedade enorme e equipe super atenciosa.',
    rating: 5
  }
];

export const companyInfo = {
  name: 'Disneylândia Cosméticos e Presentes',
  email: 'contato@disneylandiacosmeticos.com.br',
  phone: '(94) 99166-6990',
  whatsapp: '5594991666990',
  address: 'Av. Weyne Cavalcante, 720',
  city: 'Canaã dos Carajás - PA',
  zipCode: '68537-000',
  hours: 'Segunda a Sábado, 08h às 18h',
  yearsExperience: new Date().getFullYear() - 2015,
  foundedYear: 2015,
  instagram: 'https://www.instagram.com/disneylandiacosmeticoscanaa/',
  description: 'Referência em cosméticos, perfumaria e presentes em Canaã dos Carajás. As melhores marcas de beleza com atendimento personalizado.',
  about: 'A Disneylândia Cosméticos e Presentes é referência em beleza e presentes em Canaã dos Carajás. Trabalhamos com as melhores marcas nacionais e importadas de cosméticos, perfumaria, maquiagem e skincare. Oferecemos atendimento personalizado para ajudar você a encontrar o produto perfeito para cada ocasião.'
};
